// react
/* eslint-disable  */

import React, {useEffect} from 'react';

// third-party
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// application
import AsyncAction from '../shared/AsyncAction';
import Currency from '../shared/Currency';
import Indicator from './Indicator';
import { Cart20Svg, Cross10Svg } from '../../svg';
import { cartRemoveItem } from '../../store/cart';
// import {recalculatePrice} from '../../store/directusSdk'

function IndicatorCart(props) {
    const { cart, cartRemoveItem, currentUser } = props;
    const [indicatorVisible, setIndicatorVisible] = React.useState(true);

    const handleLinkClick = () => {
        setIndicatorVisible(false);
    };

    const handleIndicatorClick = () => {
        setIndicatorVisible(true);

    };
    //  useEffect(()=>{
    //     recalculatePrice(cart.items)

    //  },[currentUser])

    let dropdown;
    const totals = (
        <React.Fragment>
            <tr>
                <th>Subtotal</th>
                <td><Currency value={cart.subtotal} /></td>
            </tr>
            <tr>
                <th>Envio</th>
                <td>
                    {cart.msgEnvio && <span className={`text-${cart.delivery ? 'success' : 'danger'} mr-2`} style={{ fontSize: '0.8em' }}>{cart.msgEnvio}</span>}
                    <Currency value={cart.shipping} />
                </td>
            </tr>
            <tr>
                <th>ITBMS</th>
                <td>
                    {currentUser && currentUser?.countryid?.countrycode !== 'PA' && <span className="text-success mr-2" style={{ fontSize: '0.8em' }}>No aplica para ventas fuera de Panamá</span>}
                    <Currency value={cart.itbms} />
                </td>
            </tr>
        </React.Fragment>
    );


    const items = cart.items.map((item) => {
        let options;
        let image;

        if (item.options) {
            options = (
                <ul className="dropcart__product-options">
                    {item.options.map((option, index) => (
                        <li key={index}>{`${option.optionTitle}: ${option.valueTitle}`}</li>
                    ))}
                </ul>
            );
        }

        if (item.product.images.length) {
            image = (
                <div className="dropcart__product-image">
                    <Link to={`/shop/product/${item.product.code.replace(/\//g, '-')}/${item.product.id}`}>
                        <img src={item.product.images[0]} alt="" />
                    </Link>
                </div>
            );
        }

        const removeButton = (
            <AsyncAction
                action={() => cartRemoveItem(item.id)}
                render={({ run, loading }) => {
                    const classes = classNames('dropcart__product-remove btn btn-light btn-sm btn-svg-icon', {
                        'btn-loading': loading,
                    });

                    return (
                        <button type="button" onClick={run} className={classes}>
                            <Cross10Svg />
                        </button>
                    );
                }}
            />
        );

        return (
            <div key={item.id} className="dropcart__product">
                {image}
                <div className="dropcart__product-info">
                    <div className="dropcart__product-name">
                        <Link to={`/shop/product/${item.product.code.replace(/\//g, '-')}/${item.product.id}`}>{item.product.name}</Link>
                    </div>
                    {options}
                    <div className="dropcart__product-meta">
                        <span className="dropcart__product-quantity">{item.quantity}</span>
                        {' × '}
                        <span className="dropcart__product-price"><Currency value={parseFloat(item.price)} /></span>
                    </div>
                </div>
                {removeButton}
            </div>
        );
    });

    if (cart.quantity && indicatorVisible) {
                dropdown = (
            <div className="dropcart">
                <div className="dropcart__products-list">
                    {items}
                </div>

                <div className="dropcart__totals">
                    <table>
                        <tbody>
                            {totals}
                            <tr>
                                <th>Total</th>
                                <td><Currency value={cart.total} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="dropcart__buttons">
                    <Link className="btn btn-secondary" to="/shop/cart" onClick={handleLinkClick}>Ir al Carrito</Link>
                </div>
            </div>
        );
    } 
    

    return (
        <Indicator url="/shop/cart" dropdown={dropdown} value={cart.quantity} icon={<Cart20Svg onClick={handleIndicatorClick}/>} />
    );
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    currentUser: state.currentUser,
});

const mapDispatchToProps = {
    cartRemoveItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorCart);
